import i18n from '@/i18n';
import store from '@/store';
import packageJson from '../../package.json';
import H_card from '@/helpers/card';
import H_time from '@/helpers/time';
import Spare_common from '@/spare/common';

export default {
  deepCopyFunction(inputObject) {
    // 原始型別、null、function
    if (typeof inputObject !== 'object' || inputObject === null) {
      return inputObject;
    }
    // File / Blob（無法複製二進位內容，直接回傳）
    if (typeof Blob !== 'undefined' && inputObject instanceof Blob) {
      return inputObject;
    }
    // DOM Node（不複製 DOM）
    if (typeof Node !== 'undefined' && inputObject instanceof Node) {
      return inputObject;
    }
    // Date：建立新 Date 同時間
    if (inputObject instanceof Date) {
      return new Date(inputObject.getTime());
    }
    // RegExp：建立新 RegExp 同規則
    if (inputObject instanceof RegExp) {
      return new RegExp(inputObject.source, inputObject.flags);
    }
    // Map / Set / WeakMap / WeakSet（保持參考，不深拷）
    if (typeof Map !== 'undefined' && inputObject instanceof Map) return inputObject;
    if (typeof Set !== 'undefined' && inputObject instanceof Set) return inputObject;
    if (typeof WeakMap !== 'undefined' && inputObject instanceof WeakMap) return inputObject;
    if (typeof WeakSet !== 'undefined' && inputObject instanceof WeakSet) return inputObject;
    // Promise / Error
    if (inputObject instanceof Promise) return inputObject;
    if (inputObject instanceof Error) return inputObject;

    const outputObject = Array.isArray(inputObject) ? [] : {};
    for (let key in inputObject) {
      if (!Object.prototype.hasOwnProperty.call(inputObject, key)) continue;
      outputObject[key] = this.deepCopyFunction(inputObject[key]);
    }
    return outputObject;
  },
  getLocale(object, textKey, isI18n = true) {
    const locale = store.state.stone_auth.currentUser.locale && store.state.stone_auth.currentUser.locale.code
      ? store.state.stone_auth.currentUser.locale.code
      : 'tw';
    return object.locales && object.locales[locale]
      ? object.locales[locale][textKey]
      : isI18n
      ? i18n.t(object[textKey])
      : object[textKey];
  },
  getPercentage(num, totalNum) {
    const result = (num * 100) / totalNum || 0;
    return result.toFixed(1);
  },
  setLawList(rawData) {
    const lawList = [];
    if (rawData.act_version_alls && rawData.act_version_alls.length) {
      rawData.act_version_alls.forEach(act => {
        lawList.push({
          type: "act",
          id: act.act.id,
          versionId: act.id,
          text: act.name,
          trailingIcon: "icon-cancel",
        })
      })
    }
    if (rawData.article_versions && rawData.article_versions.length) {
      rawData.article_versions.forEach(article => {
        lawList.push({
          type: "article",
          id: article.article.id,
          text: `${
            article.act_version
              ? article.act_version.name
              : article.act_versions[0].name
          } ${article.no_text ? article.no_text : ""}`,
          trailingIcon: "icon-cancel",
          versionId: article.id,
          actVersionId: article.act_version
            ? article.act_version.id
            : article.act_versions[article.act_versions.length -1].id,
        })
      })
    }
    return lawList;
  },
  setSubmitActAndArticle(rawLawList) {
    if (!rawLawList || !rawLawList.length) return {actVersionAlls: [], articleVersions: []};
    const actVersionAlls = rawLawList
      ? rawLawList
        .filter(law => law.type === "act")
        .map(law => {
          const {
            id: act_id,
            versionId: act_version_id
          } = law;
          return {
            act_id,
            act_version_id
          };
        })
      : [];
    const articleVersions = rawLawList
      ? rawLawList
        .filter(law => law.type === "article")
        .map(law => {
          const {
            id: article_id,
            versionId: article_version_id,
            actVersionId: act_version_id
          } = law;
          return {
            article_id,
            article_version_id,
            act_version_id,
          };
        })
      : [];
    return { actVersionAlls, articleVersions };
  },
  setSelectTemplateList(rawDataList) {
    const resultList = rawDataList.map(rawData =>{
      return {
        ...rawData,
        name: rawData.status === 2
          ? `(${i18n.t('修訂中')})${rawData.name}`
          : rawData.name,
        disable: rawData.status === 2,
      };
    });
    return resultList;
  },
  setShowTemplateProps(rawData, fieldList, tarTitle, tarPropType) {
    if (!rawData) return;
    let resultProp = null;
    fieldList.forEach((field) => {
      if (
        field.title === tarTitle &&
        field.propTypeList.includes(tarPropType)
      ) {
        if (tarTitle === '領域') {
          resultProp = rawData.system_subclasses;
        }
        if (tarTitle === '狀態' && tarPropType === 'chipList') {
          resultProp = H_card.setTags(rawData, ['updated', 'status']);
        }
        if (tarTitle === '更新日期') {
          resultProp = rawData.last_version.updated_at
            ? H_time.getDateDashFormat(rawData.last_version.updated_at)
            : i18n.t('無');
        }
        if (tarTitle === '頻率') {
          const getFrequency = (frequency) => {switch(frequency){
              case 'day': return '每日';
              case 'week': return '每週';
              case 'month': return '每月';
              case 'season': return '每季';
              case 'year': return '每年';
              case 'everyTime': return '每次作業前';
              default: return '每日';
          }};
          resultProp = i18n.t(getFrequency(rawData.frequency));
        }
        if (tarTitle === '引用數量') {
          resultProp = rawData.related_count === 0
            ? '0'
            : rawData.related_count;
        }
        if (tarTitle === "類型") {
          resultProp = rawData.license_type.name;
        }
        if (tarTitle === "展延提醒日") {
          resultProp = `${rawData.last_version.statitory_extension_period}天`;
        }
        if (tarTitle === "建議展延提醒日") {
          resultProp = `${rawData.last_version.recommend_notify_period}天`;
        }
      }
    });
    return resultProp;
  },
  getComponentHeightAndY(ref) {
    if (!ref) return null;
    return ref.getBoundingClientRect();
  },
  isDropUp(dropdownHeight, dropdownTop, upperRange, lowerRange) {
    const windowHeight = window.innerHeight;
    return windowHeight - dropdownTop >= (dropdownHeight + upperRange)
      ? false
      : windowHeight - dropdownTop < (dropdownHeight + lowerRange)
      ? true
      : false;
  },
  resetBottomBar(_this) {
    if (!_this.$refs.ScrollFixedBottomBar) return;
    _this.$nextTick(()=>{
      _this.$refs.ScrollFixedBottomBar.$_getBottomBarHeight();
      _this.$refs.ScrollFixedBottomBar.$_bottomBarHide();
    }, 0)
  },
  async checkAppVersion() {
    try {
      const res = await fetch(`${window.location.origin}/version.json`, {cache: 'no-cache'});
      const {version} = await res.json();
      if (packageJson.version !== version) window.location.reload(true);
    } catch (error) {
      console.log('error: ', error);
    }
  },
  isEqual(value1, value2) {
    if (value1 === value2) return true;
    if (value1 == null || value2 == null) return false;
    const type1 = typeof value1;
    const type2 = typeof value2;
    if (type1 !== type2) return false;
    if (type1 === 'number') {
      if (Number.isNaN(value1) && Number.isNaN(value2)) return true;
      if (value1 === 0 && value2 === 0) return 1 / value1 === 1 / value2;
    }
    if (type1 === 'object') {
      const isArray1 = Array.isArray(value1);
      const isArray2 = Array.isArray(value2);
      if (isArray1 !== isArray2) return false;
      if (isArray1) {
        if (value1.length !== value2.length) return false;
        return value1.every((item, index) => this.isEqual(item, value2[index]));
      } else {
        const keys1 = Object.keys(value1);
        const keys2 = Object.keys(value2);
        if (keys1.length !== keys2.length) return false;
        return keys1.every(key =>
          Object.prototype.hasOwnProperty.call(value2, key) &&
          this.isEqual(value1[key], value2[key])
        );
      }
    }
    return value1 === value2;
  },
  getSubClassesFromIdList(subClassIdList) {
    const targetIds = new Set(subClassIdList);
    return store.state.model.systemClasses
      .flatMap(cls => cls.system_subclasses)
      .filter(subClass => targetIds.has(subClass.id));
  },
  setSubmitRolesAndFactoryRoles(scopeRoles) {
    const user_factory_roles = scopeRoles && scopeRoles[0] && scopeRoles[0].length
      ? scopeRoles[0].map(role_id => ({
          role_id,
          role_type: "factory"
        }))
      : [];
    const user_factory_role_templates = scopeRoles && scopeRoles[1] && scopeRoles[1].length
      ? scopeRoles[1].map(role_id => ({
          role_id,
          role_type: "template"
        }))
      : [];
    return {user_factory_roles, user_factory_role_templates};
  },
  formatRichContent(rawData) {
    const replacedQuot = rawData.replace(/&quot;/g, '"');
    const replacedA = replacedQuot.replace(/<a\s+([^>]*)>/g, (match, attributes) => {
      if (attributes.includes('target')) return match;
      else return `<a ${attributes} target="_blank">`;
    });
    return replacedA;
  },
  getVisibleSpaceBelowContainer(ref) {
    if (!ref) return 0;
    const container = ref.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    return viewportHeight - container.top;
  },
  async getGeolocation() {
    if (!navigator.geolocation) {
      return Promise.resolve({
        lat: '',
        lng: '',
      });
    }
    return new Promise((resolve) => {
      try {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            try {
              resolve({
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              });
            } catch (err) {
              resolve({
                lat: '',
                lng: '',
              });
            }
          },
          () => {
            resolve({
              lat: '',
              lng: '',
            });
          },
          {
            enableHighAccuracy: true,
            maximumAge: 0,
          }
        );
      } catch (err) {
        resolve({
          lat: '',
          lng: '',
        });
      }
    }).catch(() => ({
      lat: '',
      lng: '',
    }));
  },
  getMapUrl(latitude, longitude) {
    const mapBaseUrl = {
      google: (lat, lng) => `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`,
      gaode: (lat, lng) => `https://ditu.amap.com/regeo?lng=${lng}&lat=${lat}`,
      naver: (lat, lng) => `https://map.naver.com/v5/?c=${lng},${lat},17,0,0,0,d`,
    };
    const type = store.state.app.factory.mapType;
    return mapBaseUrl[type] ? mapBaseUrl[type](latitude, longitude) : mapBaseUrl.google(latitude, longitude);
  },
  separateUrlFromDomain(links) {
    return links.map(link => {
      if (link.type === 'custom') return link;
      const url = link.url;
      const isUrlEsgoal = this.checkIsUrlEsgoal(url)
      const resultUrl = isUrlEsgoal ? this.sliceUrlFromDomain(isUrlEsgoal.index, url) : url;
      return {
        ...link,
        url: resultUrl,
      };
    });
  },
  checkIsUrlEsgoal(url) {
    const domain = `https://${window.location.hostname}/`;
    const regex = new RegExp('^' + domain.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'));
    return url.match(regex);
  },
  sliceUrlFromDomain(startIndex, url) {
    const domain = `https://${window.location.hostname}/`;
    const endIndex = startIndex + domain.length;
    return url.slice(endIndex, url.length);
  },
  async copyNameAndUrl({name, fullPath}) {
    const url = new URL(fullPath, window.location.origin);
    const text = JSON.stringify({
      name: name || '',
      url: url.href,
    }, null, 2);
    await this.copyText(text);
  },
  getUrlModule(fullUrl, modulePageList) {
    const pathName = fullUrl.pathname ? fullUrl.pathname : new URL(fullUrl).pathname;
    const pathArray = pathName.split('/').filter(Boolean);
    const matchedModule = modulePageList.find(modulePage => {
      const pattern = modulePage.pattern.filter(item => item.type === 'const');
      if (pattern.length > 0) return pattern.every(item => pathArray.includes(item.key));
      return false;
    });
    return matchedModule;
  },
  async copyText(text) {
    try {
      if (!text || text.trim() === '') {
        throw new Error();
      }
      await navigator.clipboard.writeText(text);
      store.dispatch('error/setErrorMessage', '已複製');
    } catch (err) {
      store.dispatch('error/setErrorMessage', '複製失敗');
    } finally {
      store.dispatch('error/setErrorTrue');
      setTimeout(() => {
        store.dispatch('error/setErrorFalse');
        store.dispatch('error/setErrorMessage', null);
      }, 500);
    }
  },
  async pasteText() {
    try {
      return await navigator.clipboard.readText();
    } catch (err) {
      this.pasteFail();
    }
  },
  pasteFail(failText) {
    store.dispatch('error/setErrorMessage', failText || '讀取剪貼簿失敗或黏貼簿資料不正確');
    store.dispatch('error/setErrorTrue');
    setTimeout(() => {
      store.dispatch('error/setErrorFalse');
      store.dispatch('error/setErrorMessage', null);
    }, 1000);
  },
  setFactoryTagsInDataTable(factoryTags) {
    return factoryTags.map(({name: tagName}) => ({
      name: `#${tagName}`,
      color: 'gray',
    }));
  },
  getSubscriptionKey(moduleName) {
    return Spare_common.getSubscriptionMap() ? Spare_common.getSubscriptionMap()[moduleName] : null;
  },
  hasSubscription(moduleName) {
    const subscriptionKey = this.getSubscriptionKey(moduleName);
    if (!subscriptionKey) return false;
    const factory = store.state.app.factory;
    if (!factory || !factory.subscriptions || factory.subscriptions.length === 0) return false;
    const subscriptionMap = Object.fromEntries(
      factory.subscriptions.map(subscription => [subscription, true])
    );
    return subscriptionMap[subscriptionKey];
  },
  setSubscriptionMap(factory) {
    if (!factory || !factory.subscriptions || factory.subscriptions.length === 0) return null;
    return new Map(
      factory.subscriptions.map(subscription => [subscription, true])
    );
  },
}
